import { render, staticRenderFns } from "./server-create-image.vue?vue&type=template&id=284e87e6&scoped=true&"
import script from "./server-create-image.vue?vue&type=script&lang=js&"
export * from "./server-create-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e87e6",
  null
  
)

export default component.exports